module.exports = __webpack_public_path__ + "static/biodome-7e8e75db192898c67e38f593bfaf2b8f.jpg";